import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'tanok';
import * as aggs from "../../libs/aggregation";
import { getRoom, ERROR_UNIQUE_USERS, CHAT_STATUS_ACTIVE } from '@evo/chat-core';
import { t } from 'c-3po';
import { toJS } from '../helpers/ImmutableToJS';

import { Layout } from '../ui/layout';
import { Head } from '../ui/head';
import { Notice } from '../ui/notice';

import { getSocketStore } from './../../libs/utils';

// images
import EmptyChatSvg from './images/emptyChat.svg';

const NotifyView = (props) => {
    const { errors, disabledChat, closeDialog, backToChatList, hasUnreadMessage } = props;

    const imgSrc = EmptyChatSvg;
    let msgText;
    let msgTitle;

    switch (true) {
        case Boolean(errors[ERROR_UNIQUE_USERS]):
            msgText = t`Вы не можете вести диалог в чате с этим продавцом,так как
                        вошли в кабинет под его аккаунтом.
                        Для проведения диалога следует войти под другим аккаунтом,
                        без авторизации или в режиме инкогнито.`;
            break;
        case disabledChat:
            msgText = t`Вы не можете вести диалог в чате с этим продавцом,
                        так как у него отключен прием сообщений из чата.
                        Свяжитесь с ним другим доступным способом связи.`;
            break;
        default:
            msgTitle = t`Что-то пошло не так. (╯°□°）╯︵ ┻━┻`;
            msgText = t`При выполнении вашего запроса произошла внутренняя ошибка`;
    }

    return (
        <Layout>
            <Layout.Header>
                <Head
                    dataQa='chat_header'
                    hasUnreadMessage={hasUnreadMessage}
                    onBack={backToChatList()}
                    onClose={closeDialog}
                >
                    {t`Чат с продавцами`}
                </Head>
            </Layout.Header>
            <Layout.Body>
                <Notice
                    image={imgSrc}
                    title={msgTitle}
                >
                    {msgText}
                </Notice>
            </Layout.Body>
        </Layout>
    );
};

NotifyView.propTypes = {
    errors: PropTypes.object,
    disabledChat: PropTypes.bool,
    closeDialog: PropTypes.func,
    backToChatList: PropTypes.func,
};

const mapStateToProps = (state) => {
    const socketStore = getSocketStore(state);
    const currentChatRoom = getRoom(socketStore, state.get('openedRoomIdent'));
    const isPortalChatVisible = !!currentChatRoom.getIn(['extra', 'is_portal_chat_visible']);

    return {
        errors: state.get('errors'),
        disabledChat: !isPortalChatVisible,
        locale: state.get('locale'),
        hasUnreadMessage: aggs.hasUnreadMessage(
            socketStore.get('chats'),
            CHAT_STATUS_ACTIVE
        )
    };
};

export const Notify = connect(mapStateToProps)(toJS(NotifyView));
